import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { InputTextModule } from 'primeng/inputtext';
import { TableModule } from 'primeng/table';
import { Subject } from 'rxjs/internal/Subject';
import { TablepageBaseComponent } from '../../abstract/tablepage-base/tablepage-base.component';
import { PatientHeaderComponent } from '../../components/patient-header/patient-header.component';
import { PatientRowComponent } from '../../components/patient-row/patient-row.component';
import { UserStatus } from '../../models/dashboard';
import { ApiService } from '../../services/api.service';
import { UiNotificationService } from '../../services/ui-notification.service';
import { Parameters } from '../../utilities/parameters';

@Component({
  selector: 'app-patients',
  imports: [
    FormsModule,
    CommonModule,
    TablepageBaseComponent,
    TableModule,
    InputTextModule,
    PatientHeaderComponent,
    PatientRowComponent,
    TranslatePipe
  ],
  standalone: true,
  templateUrl: './patients.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: ``,
})
export class PatientsComponent implements OnInit, OnDestroy {
  messageService = inject(UiNotificationService);
  routerService = inject(Router);

  loading: boolean = false;
  dtTrigger: Subject<boolean> = new Subject<boolean>();

  users: UserStatus[] = [];

  constructor(private apiService: ApiService) {
  }

  ngOnInit(): void {
    this.loadData();
  }

  ngOnDestroy() {
    this.dtTrigger.unsubscribe();
  }

  private loadData(): void {
     this.loading = true;

    this.apiService.getPatients(Parameters.loggedUser.id).subscribe({
      next: (data) => {
        this.users = data;
        this.dtTrigger.next(true);
      },
      error: (err: HttpErrorResponse) => {
        this.loading = false;
        this.messageService.showError(err);
      },
      complete: () => {
        this.loading = false;
      }
    })
  }
}
